function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuotes = function SvgQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M920.815 332.129c1.053.255 2.037.851 2.95 1.786 1.258 1.287 1.887 2.895 1.887 4.825 0 2.047-.702 3.817-2.106 5.308-1.404 1.492-3.129 2.237-5.176 2.237-1.989 0-3.714-.731-5.177-2.193-1.462-1.462-2.193-3.246-2.193-5.352 0-.819.175-1.798.526-2.939.351-1.14.995-2.588 1.931-4.343L920.212 319l5.966 3.158-5.363 9.971Zm18.863 0c1.053.255 2.036.851 2.95 1.786 1.258 1.287 1.887 2.895 1.887 4.825 0 2.047-.717 3.817-2.15 5.308-1.433 1.492-3.173 2.237-5.22 2.237-1.93 0-3.627-.731-5.089-2.193-1.462-1.462-2.193-3.246-2.193-5.352 0-.819.175-1.798.526-2.939.351-1.14.995-2.588 1.93-4.343L939.075 319l5.966 3.158-5.363 9.971Z",
    style: {
      fillRule: "nonzero"
    },
    transform: "translate(-911 -319)"
  }));
};
export default SvgQuotes;